import {
  WITHDRAW_LIST,
  ALL_GATEWAYS,
  SELECTED_GATEWAY,
  PLAYER_BANK_DETAILS,
} from "./types";
import { API_URLS } from "../../config/apiUrls";
import { axiosService } from "../../utils/axiosService";
import { Toaster } from "../../utils/toaster";
import { APP_CONST } from "../../config/const";
import axios, { AxiosError } from "axios";

export const getAccountStatement = async (data) => {
  try {
    return await axiosService.get(
      `${API_URLS.USER.ACCOUNT_STATEMENT}/${data?.from}/${data?.to}`
    );
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Failed to fetch records"
      );
    }
  }
};

// despoit create

export const createDeposit = async (payload) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.CREATE_DEPOSIT,
      payload,
      {
        headers: {
          "Content-Type": `multipart/form-data`,
        },
      }
    );
    return result;
  } catch (err) {
    console.log(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to create request"
      );
    }
  }
};

export const createWithDrawRequest = (payload) => (dispatch) => {
  try {
    const result = axiosService.post(
      API_URLS.USER.CREATE_WITHDRAW_REQUEST,
      payload
    );
    return result;
  } catch (err) {
    console.debug(err);
  }
};

// get withdrawlist

export const getWithdrawList = async (query) => {
  try {
    return await axiosService.get(
      `${API_URLS.USER.GET_WITHDRAW_LIST}?${query}`
    );
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Failed to get list");
    }
  }
};

// cancel request

export const cancelWithdrawList = (payload) => {
  try {
    return axiosService.post(API_URLS.USER.CANCEL_WITHDRAW_REQUEST, payload);
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to cancel request"
      );
    }
  }
};

export const getOnlinePaymentLink = async (data) => {
  try {
    // const result = await axiosService.post(API_URLS.USER.FLOXY_DEPOSIT, data);
    const result = await axiosService.post(
      API_URLS.USER.FASTPAYME_DEPOSIT,
      data
    );
    if (result.data && result?.data?.data?.data) {
      return result.data.data.data;
    }

    return null;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to create payment"
      );
    }
    // console.debug(err);
    return null;
  }
};

/**
 * Get all gateways from server
 */
export const getAllGateways = async () => {
  try {
    return await axiosService.get(API_URLS.USER.GET_ALL_GATEWAYS);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to get gateways"
      );
    }
  }
};

/**
 * Get one gateway from server
 * @param {string} gtwId
 */

export const getOneGateway = async (gtwId) => {
  try {
    return await axiosService.get(`${API_URLS.USER.GET_ALL_GATEWAYS}/${gtwId}`);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to get gateway"
      );
    }
  }
};

export const setSelectedGateway = (payload) => (dispatch) => {
  dispatch({
    type: SELECTED_GATEWAY,
    payload: payload,
  });
};

export const updateDepositAmount = async (payload) => {
  try {
    let headers = {};
    if (payload?.isMultiPart == true) {
      headers["Content-Type"] = `multipart/form-data`;
    }
    const result = await axiosService.post(
      payload.url,
      payload?.isMultiPart ? objectToFormData(payload.data) : payload.data,
      {
        headers,
      }
    );
    return result;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Payment Failed"
      );
    }
    console.debug(err);
  }
};

export const addPlayerBankDetails = async (payload) => {
  try {
    return await axiosService.post(API_URLS.USER.PLAYER_BANK_DETAILS, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to add details"
      );
    }
    console.debug(err);
  }
};

export const getPlayerBankDetails = (query) => (dispatch) => {
  try {
    const result = axiosService.get(
      `${API_URLS.USER.PLAYER_BANK_DETAILS}${query}`
    );
    result.then((res) => {
      dispatch({
        type: PLAYER_BANK_DETAILS,
        payload: res?.data?.data?.data,
      });
    });
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to get details"
      );
    }
  }
};

export const updatePlayerBankDetails = async (payload) => {
  try {
    return await axiosService.patch(API_URLS.USER.PLAYER_BANK_DETAILS, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to get details"
      );
    }
  }
};

export const detelePlayerBankRecord = async (id) => {
  try {
    return await axiosService.delete(`${API_URLS.USER.PLAYER_BANK_DETAILS}`, {
      data: {
        id: id,
      },
    });
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to delete record"
      );
    }
  }
};

// Update profile : PATCH
export const updateProfile = async (payload) => {
  try {
    return await axiosService.patch(API_URLS.USER.PROFILE, payload);
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to update profile"
      );
    }
  }
};

// Get deposit request

export const getDepositRequest = async (query) => {
  const { data, error } = await axiosService({
    url: `${API_URLS.USER.DEPOSIT_GET}?${query}`,
  });
  return data;
};

/**
 * Create dynamic manual withdraw request
 */
export const createDynamicManualWithdrawRequest = async ({
  payload,
  isMultiPart = false,
}) => {
  try {
    let headers = {};
    if (isMultiPart) {
      headers["Content-Type"] = `multipart/form-data`;
    }
    return await axiosService.post(
      API_URLS.USER.DYNAMIC_MANUAL_WITHDRAW,
      isMultiPart ? objectToFormData(payload) : payload,
      {
        headers: headers,
      }
    );
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to create request"
      );
    }
  }
};

function objectToFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;

  for (let propertyName in obj) {
    if (!obj.hasOwnProperty(propertyName) || obj[propertyName] === undefined) {
      continue;
    }

    if (namespace) {
      formKey = `${namespace}[${propertyName}]`;
    } else {
      formKey = propertyName;
    }

    if (
      typeof obj[propertyName] === "object" &&
      !(obj[propertyName] instanceof File) &&
      obj[propertyName] !== null
    ) {
      objectToFormData(obj[propertyName], fd, formKey);
    } else if (obj[propertyName] === null) {
      fd.append(formKey, "");
    } else {
      fd.append(formKey, obj[propertyName]);
    }
  }
  return fd;
}

/**
 * Request withdraw OTP
 */

export const requestWithdrawOtp = async (payload) => {
  try {
    return await axiosService.post(API_URLS.USER.REQUEST_WITHDRAW_OTP, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Failed to generate withdraw OTP");
    }
  }
};
